export enum AddressType {
    Work = 'address.work',
    Private = 'address.home',
}
